<div class="dummy-rewarded-player">
    <div class="dummy-rewarded-player__panel">
        <div class="dummy-rewarded-player__badge">DUMMY AD</div>

        <div class="dummy-rewarded-player__countdown">
            <span *ngIf="!rewardReady">Reward in {{ remaining }}s</span>
            <span *ngIf="rewardReady">Video finished — claim your reward</span>
        </div>

        <div class="dummy-rewarded-player__actions">
            <button type="button"
                    class="dummy-rewarded-player__btn dummy-rewarded-player__btn--complete"
                    [disabled]="!rewardReady"
                    (click)="settle('complete')">
                <span *ngIf="rewardReady">Complete (simulate)</span>
                <span *ngIf="!rewardReady">Complete (wait {{ remaining }}s)</span>
            </button>
            <button type="button" class="dummy-rewarded-player__btn" (click)="settle('skipped')">Skip</button>
            <button type="button" class="dummy-rewarded-player__btn" (click)="settle('error')">Simulate error</button>
        </div>
    </div>
</div>
